import confetti from "canvas-confetti";

const BRAND = ["#3730A3", "#EC4899", "#EAB308", "#A855F7", "#0EA5E9", "#10B981"];

const reducedMotion = () =>
  typeof window !== "undefined" &&
  window.matchMedia &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

function subtleFallback() {
  confetti({
    particleCount: 24,
    spread: 60,
    startVelocity: 18,
    gravity: 0.6,
    ticks: 90,
    scalar: 0.8,
    origin: { x: 0.5, y: 0.4 },
    colors: BRAND,
    disableForReducedMotion: false,
  });
}

export function celebrate() {
  if (typeof window === "undefined") return;
  if (reducedMotion()) return subtleFallback();

  const shoot = (origin, opts = {}) =>
    confetti({
      particleCount: 60,
      spread: 75,
      startVelocity: 45,
      gravity: 0.9,
      ticks: 220,
      scalar: 1,
      zIndex: 9999,
      colors: BRAND,
      origin,
      ...opts,
    });

  shoot({ x: 0.5, y: 0.55 }, { particleCount: 90, spread: 100, startVelocity: 50 });
  shoot({ x: 0.02, y: 0.85 }, { angle: 60, particleCount: 70, spread: 65 });
  shoot({ x: 0.98, y: 0.85 }, { angle: 120, particleCount: 70, spread: 65 });

  const timers = [
    setTimeout(() => {
      shoot({ x: 0.25, y: 0.15 }, { angle: 280, spread: 110, shapes: ["square"], scalar: 1.1 });
      shoot({ x: 0.75, y: 0.15 }, { angle: 260, spread: 110, shapes: ["circle"], scalar: 0.9 });
    }, 350),
    setTimeout(() => {
      shoot({ x: 0.5, y: 0.2 }, { particleCount: 80, spread: 140, startVelocity: 35, scalar: 1.2 });
      shoot({ x: 0.12, y: 0.5 }, { angle: 45, particleCount: 50, spread: 80 });
      shoot({ x: 0.88, y: 0.5 }, { angle: 135, particleCount: 50, spread: 80 });
    }, 800),
    setTimeout(() => {
      shoot({ x: 0.35, y: 0.7 }, { particleCount: 45, spread: 120, startVelocity: 30, scalar: 0.85 });
      shoot({ x: 0.65, y: 0.7 }, { particleCount: 45, spread: 120, startVelocity: 30, scalar: 0.85 });
    }, 1400),
  ];
  return () => timers.forEach(clearTimeout);
}

export function celebrateOnce(key) {
  if (typeof window === "undefined") return;
  if (sessionStorage.getItem(key)) return;
  sessionStorage.setItem(key, "1");
  celebrate();
}
